import React from 'react';

interface SpanOptionProps extends React.HTMLAttributes<HTMLSpanElement> {
  text: string;
  disableUnderline?: boolean;
  isSet?: any;
  isSpecial?: boolean;
}

export const SpanOption = ({ text, onClick, className, disableUnderline, isSet, isSpecial, ...rest }: SpanOptionProps) => {
  const classes = [
    'option',
    isSpecial ? 'special' : null,
    onClick ? 'interactive' : null,
    disableUnderline ? 'no-underline' : null,
    className || null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={classes}
      onClick={onClick}
      {...rest}
    >
      {text}
    </span>
  );
};

